import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import isEmpty from 'lodash.isempty'
import * as user from 'services/user/selectors'
import * as premium from 'services/premium/selectors'
import * as userStatsActions from 'services/userStats/actions'
import * as userStats from 'services/userStats/selectors'
import SidebarWidget from 'components/sidebar/SidebarWidget'
import StatsSummary from './StatsSummary'
import mvpImg from 'images/mvp_badge.png'
import styles from './_userSummary.css'

const mapStateToProps = (state) => ({
  displayName: user.selectDisplayName(state),
  location: user.selectLocation(state),
  profileImg: user.selectProfileImgMed(state),
  isPremium: premium.selectIsPremium(state),
  userId: user.selectUserId(state),
  summaryStats: userStats.selectSummaryStats(state),
  unitPreference: user.selectUnitPreference(state),
})

const mapDispatchToActions = {
  ...userStatsActions,
}

export class UserSummary extends Component {
  static propTypes = {
    displayName: PropTypes.string,
    location: PropTypes.object,
    profileImg: PropTypes.string,
    isPremium: PropTypes.bool,
    getLifetimeStats: PropTypes.func,
    userId: PropTypes.number,
    summaryStats: PropTypes.object,
    unitPreference: PropTypes.string,
  }

  componentWillMount () {
    this.props.getLifetimeStats(this.props.userId)
  }

  render () {
    return (
      <SidebarWidget>
        <div className={styles.userContainer}>
          <div className={styles.userImageContainer}>
            <img
              src={this.props.profileImg}
              alt={this.props.displayName}
              className={styles.profileImg} />
            {this.props.isPremium ?
              <span className={styles.proHighlight}>
                <img
                  src={mvpImg}
                  className={styles.mvpImg}
                  alt="MVP" />
              </span>
            : null}
          </div>
          <h5 className={styles.displayName}>{this.props.displayName}</h5>
          <p className={styles.location}>{this.props.location.locality}, {this.props.location.region}</p>
          <div className={styles.userStats}>
            { this.props.summaryStats && !isEmpty(this.props.summaryStats) ?
              <StatsSummary unitPreference={this.props.unitPreference} totals={this.props.summaryStats} />
            : null }
          </div>
        </div>
        <div className={styles.linksContainer}>
          <Link to="/people/friends/find/">
            <FormattedMessage id='home.userSummary.findFriends' defaultMessage='Find Friends' />
          </Link>
          <a href="/account/my_profile">
            <FormattedMessage id='home.userSummary.editProfile' defaultMessage='Edit Profile' />
          </a>
        </div>
      </SidebarWidget>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(UserSummary)
